export default "__VITE_ASSET__BBBcLNWI__"